import { useTranslation } from 'react-i18next'

interface Props {
  message: string
  onRetry?: () => void
}

/**
 * Shared failure state for data panels, so a rejected request shows something
 * actionable instead of rendering an empty shell.
 */
const LoadFailed = ({ message, onRetry }: Props) => {
  const { t } = useTranslation()

  return (
    <div className='flex flex-col items-center justify-center gap-3 py-10 text-center'>
      <p className='text-lightGray text-lg'>{message}</p>
      {onRetry && (
        <button
          type='button'
          onClick={onRetry}
          className='text-primaryBlue font-semibold hover:underline'
        >
          {t('tryAgain')}
        </button>
      )}
    </div>
  )
}

export default LoadFailed
